import * as Sentry from '@sentry/react'
import { browserTracingIntegration } from '@sentry/browser'

if (window.isDevMode) {
  console.log('Sentry options', {
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.VITE_MODE || 'stage'
  })
}

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.VITE_MODE || 'stage',
  integrations: [browserTracingIntegration(), Sentry.replayIntegration()],
  tracesSampleRate: 0.05,
  sampleRate: 1.0,
  replaysSessionSampleRate: 0.01,
  replaysOnErrorSampleRate: 1.0,
  beforeSend(event) {
    return event
  }
})
